import React from 'react';
import { ImageIcon } from 'lucide-react';
type ImageSlotProps = {
  src: string;
  alt: string;
  label: string;
  className?: string;
  imgClassName?: string;
  placeholderClassName?: string;
};
export function ImageSlot({
  src,
  alt,
  label,
  className = '',
  imgClassName = 'h-auto w-full',
  placeholderClassName = 'aspect-[4/3]'
}: ImageSlotProps) {
  if (src) {
    return <div className={className} data-id="element-129" data-mp="2jgglx55tm970">
        <img src={src} alt={alt} className={imgClassName} data-id="element-130" data-mp="2jf5gz20n2veb" />
      </div>;
  }
  return <div role="img" aria-label={alt} className={`flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-gold-soft/40 bg-night-panel px-4 text-center ${placeholderClassName} ${className}`} data-id="element-131" data-mp="2oe9rbvzauz68">
      <ImageIcon className="h-7 w-7 text-gold-soft/70" aria-hidden="true" data-id="element-132" data-mp="2x9pw381leyql" />
      <span className="font-sans text-sm font-medium text-parchment/60" data-id="element-133" data-mp="3289if9k3mcjh">{label}</span>
    </div>;
}